import Vue from 'vue';
import store from '@/store';

Vue.mixin({
  computed: {
    $user() {
      return store.getters['auth/user'];
    },
    $isAccess() {
      return store.getters['auth/isAccessAllowed'];
    },
  },
  methods: {
    $notEmpty(value) {
      if (Array.isArray(value)) {
        return value.length;
      }
      if (typeof value === 'string') {
        return value;
      }
      if (typeof value === 'boolean') {
        return true;
      }
      return typeof value === 'number';
    },
  },
});
